import { VyStack } from '@vy/ui-design-system';
import { useEffect } from 'react';
import { useFormErrorNotificationContext } from '../../../../../../contexts/form-error-notification-context/form-error-notification-context';
import { CREATE_PLAN_TABS, type CreatePlanTab } from '../../CreatePlanPageTabs/create-plan-page-types/create-plan-tab';
import { useChargeContext } from '../../charge-context';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import {
  DiscountSection,
  InstallmentsSection,
  PaymentSection,
  PricingSection,
  ScheduleSection,
} from '../sections';

export function CommercialTermsVariant() {
  const { itemIndex: productIndex, isInvoice } = useChargeContext();
  const { registerErrorField } = useFormErrorNotificationContext<PlanInputForm, CreatePlanTab>();

  useEffect(() => {
    registerErrorField(`fixedProducts.${productIndex}.billingInterval`, CREATE_PLAN_TABS.serviceFees);
  }, [registerErrorField, productIndex]);

  return (
    <VyStack sx={{ gap: 2.5 }}>
      <PricingSection showAutoPriceUplift={false} />
      <DiscountSection />
      <ScheduleSection showFixedStartDate />
      {!isInvoice && <InstallmentsSection />}
      <PaymentSection showSeparateInvoice={!isInvoice} />
    </VyStack>
  );
}
